// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"186":"5ea27e5c9dd48442fdad","888":"4ad9a3a00221450f29b4"}[chunkId] + ".css";
};